import { Loader2 } from "lucide-react";
import type { InboxViewSuggestion } from "@/types/inboxView/inboxView";
import { GenieIcon } from "@/components/ui/genie-icons/GenieIcon";

interface Props {
  suggestion: InboxViewSuggestion;
  onPick: () => void;
  pending?: boolean;
}

export const SuggestionCard = ({ suggestion, onPick, pending }: Props) => {
  return (
    <div className="bg-white border border-[#E5EAF0] rounded-2xl p-5 flex flex-col h-full">
      <div className="flex items-start gap-3">
        <div className="h-8 w-8 rounded-lg bg-gradient-to-br from-[#4E9CFF]/10 to-[#FF4DB8]/10 flex items-center justify-center shrink-0">
          <GenieIcon
            name="document"
            size={18}
            color="#4E9CFF"
            secondaryColor="#FF4DB8"
            gradientEnabled
            label="Suggested view"
          />
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold text-[#222B45]">{suggestion.title}</div>
          <div className="text-xs text-[#64748B] mt-1 leading-snug">{suggestion.prompt}</div>
        </div>
      </div>

      <div className="mt-3 flex flex-wrap gap-1.5">
        {suggestion.columns.slice(0, 6).map((c) => (
          <span key={c.name} className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-[#FAFCFF] border border-[#E5EAF0] text-[#64748B]">
            {c.name}
          </span>
        ))}
      </div>

      <button
        onClick={onPick}
        disabled={pending}
        className="mt-4 w-full inline-flex items-center justify-center gap-2 px-4 py-2 rounded-xl text-white text-sm font-semibold disabled:opacity-60 disabled:cursor-not-allowed"
        style={{ background: "linear-gradient(90deg, #4E9CFF 0%, #FF4DB8 100%)" }}
      >
        {pending ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
        Create this view
      </button>
    </div>
  );
};
